import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { rgpdClient } from '../../lib/rgpd';
import { PrivacyPolicyLink } from '../privacy/PrivacyPolicyLink';
import { resolveColor } from '../../utils/colorUtils';

interface FooterProps {
  config: any;
}

export const Footer: React.FC<FooterProps> = ({ config }) => {
  const { data: rgpdConfig } = useQuery({
    queryKey: ['rgpd-config'],
    queryFn: () => rgpdClient.getConfig(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });

  useEffect(() => {
    return () => {
      // cleanup effect if needed
    };
  }, []);

  if (!rgpdConfig) {
    return null;
  }

  const footerBackgroundColor = resolveColor(config['HFBack-color'], config, config['dark-color']);
  const footerTextColor = resolveColor(config['HFTxt-color'], config, config['light-color']);

  return (
    <footer 
      className="fixed bottom-0 left-0 right-0 z-[300] h-10 bg-inherit flex items-center"
      style={{ backgroundColor: footerBackgroundColor }}
    >
      <div className="w-full px-4 flex items-center justify-between">
        <span 
          className="text-xs"
          style={{ color: footerTextColor }}
        >
          © {new Date().getFullYear()} {config.name}
        </span>
        <div className="flex items-center gap-4 text-xs">
          <PrivacyPolicyLink 
            config={{ ...config, 'light-color': footerTextColor }} 
            rgpdConfig={rgpdConfig} 
          />
        </div>
      </div>
    </footer>
  );
};
